export default __webpack_public_path__ + "static/blank-f9e47c315b03fee6676050bd19597f22.svg";